import React, { ReactNode } from 'react';
import './Panel.css';

export type PanelPurpose = 'settings' | 'commerce' | 'summary';

export interface PanelProps {
  purpose: PanelPurpose;
  /** Id of the heading that names this group; makes the panel a labelled region. */
  labelledBy?: string;
  className?: string;
  id?: string;
  children: ReactNode;
}

/**
 * Translucent 16px surface used only when grouping needs it. `purpose` is a
 * data attribute for tests and review, never a style switch.
 */
const Panel: React.FC<PanelProps> = ({ purpose, labelledBy, className, id, children }) => {
  const classes = `luma-panel${className ? ` ${className}` : ''}`;
  if (labelledBy) {
    return (
      <section id={id} className={classes} data-purpose={purpose} aria-labelledby={labelledBy}>
        {children}
      </section>
    );
  }
  return (
    <div id={id} className={classes} data-purpose={purpose}>
      {children}
    </div>
  );
};

export default Panel;
